import React, { FC, useMemo } from 'react';
import useAuth from 'src/hooks/api/useAuth';
import Agency, { DB_AGENCIES } from 'src/interfaces/api/Agency';
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select } from '@material-ui/core';
import useAgencies from 'src/hooks/api/useAgencies';

interface Props {
  value: string[];
  onChange: (value: string[]) => void;
  className?: string;
}

const AgencySelect: FC<Props> = ({ value, onChange, className }) => {
  const { token } = useAuth();
  const { agencies } = useAgencies();

  const choices: Agency[] = useMemo(() => {
    if (agencies.status !== 'fetched') {
      return [];
    }

    if (token?.agenciesIds.includes(DB_AGENCIES.MEYLAN) || token?.agenciesIds.includes(DB_AGENCIES.ASSODIA)) {
      return agencies.data.filter((a) => [DB_AGENCIES.MEYLAN, DB_AGENCIES.ASSODIA].includes(a.id as DB_AGENCIES));
    }
    return agencies.data.filter((a) => token?.agenciesIds.includes(a.id));
  }, [agencies, token]);

  const renderValue = (selectedIds) =>
    agencies.status === 'fetched'
      ? agencies.data
          .filter((a) => selectedIds.includes(a.id))
          .map((a) => a.name)
          .join(', ')
      : '';

  const handleChange = (event: React.ChangeEvent<{ name?: string; value: any }>) => {
    const id = event.target.value;
    onChange(id);
  };

  return (
    <FormControl size='small' variant='outlined' className={className}>
      <InputLabel>Agence</InputLabel>
      <Select multiple renderValue={renderValue} onChange={handleChange} label='Agence' value={value}>
        {choices.map((agency, key) => (
          <MenuItem key={key} value={agency.id}>
            <Checkbox checked={value.indexOf(agency.id) > -1} />
            <ListItemText primary={agency.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AgencySelect;
